import Card from "./index.vue"
import CardItem from "./Item.vue"

const install=(Vue)=>{
    Vue.component("JimiCard",Card)
    Vue.component("JimiCardItem",CardItem)
}

export default install